// src/app/pages/ChatHistoryPage/index.tsx
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { observer } from "mobx-react-lite";
import { TextGenerationViewModel } from "@/app/core/chatPage/chatCopmonents/shared/TextGenerationViewModel";
import { ConversationSidebar } from "@/app/core/chatPage/chatCopmonents/chatInForm/components/ConversationSidebar";
import { useTranslation } from "@/app/core/ui/theme/LanguageProvider";

export const ChatHistoryPage = observer(() => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const viewModel = TextGenerationViewModel.getInstance();

  return (
    <div className="flex flex-col h-full bg-transparent">
      {/* Стеклянная шапка */}
      <div className="flex-shrink-0 glass mx-2 mt-2 rounded-2xl">
        <div className="max-w-[var(--container-max-width,672px)] mx-auto px-4 py-3 flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="-ml-2 p-2 rounded-lg hover:bg-white/10 transition-colors"
            aria-label={t("back")}
          >
            <ArrowLeft className="h-5 w-5" />
          </button>
          <h2 className="text-lg font-semibold text-foreground">{t("chatHistory")}</h2>
        </div>
      </div>

      {/* Прозрачный контент */}
      <div className="flex-1 min-h-0">
        <ConversationSidebar
          conversations={viewModel.conversations}
          activeConversationId={viewModel.activeConversationDbId}
          onSelectConversation={(conv) => {
            viewModel.selectConversation(conv);
            navigate("/text-generation");
          }}
          onStartNewConversation={() => {
            viewModel.startNewConversation();
            navigate("/text-generation");
          }}
          onDeleteConversation={(id) => viewModel.deleteConversation(id)}
          onRenameConversation={(id, newTitle) => viewModel.renameConversation(id, newTitle)}
          isFullPage
        />
      </div>
    </div>
  );
});